import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useCart } from "../contexts/CartContext";
import { useAuth } from "../contexts/AuthContext";
import SearchBar from "./SearchBar";
import LoginRegisterModal from "./LoginRegisterModal";
import "../index.css";

function Header() {
  const [showAccountMenu, setShowAccountMenu] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showLiveSoonModal, setShowLiveSoonModal] = useState(false);
  const [viewItem, setViewItem] = useState(null);
  const [pendingProduct, setPendingProduct] = useState(null);
  const [showMobileMenu, setShowMobileMenu] = useState(false);

  const { cartItems, addToCart, toggleSidebar, openSidebar } = useCart();
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const totalItems = cartItems.reduce((sum, item) => sum + item.qty, 0);
  const oneSystem = "https://onesystem.asherjewels.com.ph/";

  useEffect(() => {
    const closeMenu = (e) => {
      if (!e.target.closest(".account-dropdown")) {
        setShowAccountMenu(false);
      }
      if (!e.target.closest(".mobile-nav-menu") && !e.target.closest(".mobile-nav-toggle")) {
        setShowMobileMenu(false);
      }
    };
    document.addEventListener("click", closeMenu);
    return () => document.removeEventListener("click", closeMenu);
  }, []);

  const handleLogout = () => {
    logout();
    setShowMobileMenu(false);
    navigate("/");
  };

  const handleAddToCart = (product) => {
    if (!user) {
      setPendingProduct(product);
      setShowModal(true);
      return;
    }

    addToCart({ ...product, qty: 1 }).then(() => {
      openSidebar();
    });
  };

  const handleLiveSoonOpen = () => {
    setShowMobileMenu(false);
    setShowLiveSoonModal(true);
  };

  return (
    <>
      <div className="top-bar">
        <div className="top-bar-left">
          <span className="top-bar-pill">
            <span className="top-bar-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" role="presentation" focusable="false">
                <path d="M5 4.5h3l1.2 3.2-1.8 1.8a14.5 14.5 0 0 0 7.1 7.1l1.8-1.8L19.5 16v3A1.5 1.5 0 0 1 18 20.5A14.5 14.5 0 0 1 3.5 6A1.5 1.5 0 0 1 5 4.5Z" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </span>
            <span>Call us: <a href="tel:+639707578888">+63 970 757 8888</a></span>
          </span>
        </div>
        <div className="top-bar-right">
          {!user ? (
            <button className="login-button" onClick={() => setShowModal(true)}>
              Login | Register
            </button>
          ) : (
            <div className="account-dropdown">
              <span
                className="user-toggle"
                onClick={(e) => {
                  e.stopPropagation();
                  setShowAccountMenu((prev) => !prev);
                }}
              >
                <span className="user-toggle__avatar" aria-hidden="true">
                  <svg viewBox="0 0 24 24" role="presentation" focusable="false">
                    <circle cx="12" cy="8" r="3.25" fill="none" stroke="currentColor" strokeWidth="1.7"/>
                    <path d="M6.5 18.5c1.35-2.55 3.32-3.82 5.5-3.82s4.15 1.27 5.5 3.82" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/>
                  </svg>
                </span>
                <span className="user-toggle__text">Hi, {user.full_name}</span>
                <span className="chevron" aria-hidden="true" style={{ transform: showAccountMenu ? "rotate(180deg)" : "rotate(0)" }}>
                  <svg viewBox="0 0 12 12" role="presentation" focusable="false">
                    <path d="M2.25 4.5 6 8.25 9.75 4.5" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </span>
              </span>

              {showAccountMenu && (
                <div className="dropdown-menu">
                  <Link to="/account">
                    <span className="dropdown-menu__icon" aria-hidden="true">
                      <svg viewBox="0 0 24 24" role="presentation" focusable="false"><circle cx="12" cy="8" r="3.25" fill="none" stroke="currentColor" strokeWidth="1.7"/><path d="M6.5 18.5c1.35-2.55 3.32-3.82 5.5-3.82s4.15 1.27 5.5 3.82" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/></svg>
                    </span>
                    <span>My Account</span>
                  </Link>
                  <Link to="/wishlist">
                    <span className="dropdown-menu__icon" aria-hidden="true">
                      <svg viewBox="0 0 24 24" role="presentation" focusable="false"><path d="M12 19.75l-1.1-.96C6.13 14.62 3.5 12.16 3.5 8.92A3.92 3.92 0 0 1 7.45 5a4.3 4.3 0 0 1 4.55 2.73A4.3 4.3 0 0 1 16.55 5a3.92 3.92 0 0 1 3.95 3.92c0 3.24-2.63 5.7-7.4 9.87L12 19.75Z" fill="none" stroke="currentColor" strokeWidth="1.65" strokeLinejoin="round"/></svg>
                    </span>
                    <span>My Wishlist</span>
                  </Link>
                  <Link to="/orders">
                    <span className="dropdown-menu__icon" aria-hidden="true">
                      <svg viewBox="0 0 24 24" role="presentation" focusable="false"><path d="M6.5 4.75h11A1.75 1.75 0 0 1 19.25 6.5v11A1.75 1.75 0 0 1 17.5 19.25h-11A1.75 1.75 0 0 1 4.75 17.5v-11A1.75 1.75 0 0 1 6.5 4.75Z" fill="none" stroke="currentColor" strokeWidth="1.65"/><path d="M8 9.25h8M8 12h8M8 14.75h5.5" fill="none" stroke="currentColor" strokeWidth="1.65" strokeLinecap="round"/></svg>
                    </span>
                    <span>Orders</span>
                  </Link>
                  <button onClick={handleLogout}>
                    <span className="dropdown-menu__icon" aria-hidden="true">
                      <svg viewBox="0 0 24 24" role="presentation" focusable="false"><path d="M10 6.75H7.75A1.75 1.75 0 0 0 6 8.5v7A1.75 1.75 0 0 0 7.75 17.25H10" fill="none" stroke="currentColor" strokeWidth="1.65" strokeLinecap="round"/><path d="M13 8.25 17 12l-4 3.75" fill="none" stroke="currentColor" strokeWidth="1.65" strokeLinecap="round" strokeLinejoin="round"/><path d="M17 12H9.5" fill="none" stroke="currentColor" strokeWidth="1.65" strokeLinecap="round"/></svg>
                    </span>
                    <span>Logout</span>
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      <header className="header-bar">
        <button
          type="button"
          className="mobile-nav-toggle"
          aria-label="Open menu"
          aria-expanded={showMobileMenu}
          onClick={() => setShowMobileMenu((prev) => !prev)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <div className="logo-block">
          <Link to="/">
            <img
              src="/pngb-logo.jpg"
              alt="Asher Jewels PH"
              className="logo-fixed-width blink-gold-only"
            />
          </Link>
        </div>

        <nav className="shop-nav" aria-label="Primary navigation">
          <Link to="/" className="shop-nav__link">
            <span className="shop-nav__icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" role="presentation" focusable="false"><path d="M4.75 10.5L12 4.75l7.25 5.75V19a.75.75 0 0 1-.75.75H14v-5.25h-4v5.25H5.5A.75.75 0 0 1 4.75 19v-8.5Z" fill="none" stroke="currentColor" strokeWidth="1.65" strokeLinejoin="round"/></svg>
            </span>
            <span>Home</span>
          </Link>
          <Link to="/shop" className="shop-nav__link">
            <span className="shop-nav__icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" role="presentation" focusable="false"><path d="M5.75 7.25h12.5l-1 10.25a1.5 1.5 0 0 1-1.49 1.35H8.24a1.5 1.5 0 0 1-1.49-1.35L5.75 7.25Z" fill="none" stroke="currentColor" strokeWidth="1.65" strokeLinejoin="round"/><path d="M8.75 7.25a3.25 3.25 0 0 1 6.5 0" fill="none" stroke="currentColor" strokeWidth="1.65" strokeLinecap="round"/></svg>
            </span>
            <span>Shop</span>
          </Link>
          <Link to="/wishlist" className="shop-nav__link">
            <span className="shop-nav__icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" role="presentation" focusable="false"><path d="M12 19.75l-1.1-.96C6.13 14.62 3.5 12.16 3.5 8.92A3.92 3.92 0 0 1 7.45 5a4.3 4.3 0 0 1 4.55 2.73A4.3 4.3 0 0 1 16.55 5a3.92 3.92 0 0 1 3.95 3.92c0 3.24-2.63 5.7-7.4 9.87L12 19.75Z" fill="none" stroke="currentColor" strokeWidth="1.65" strokeLinejoin="round"/></svg>
            </span>
            <span>My Wishlist</span>
          </Link>
          <Link to="/about-us" className="shop-nav__link">
            <span className="shop-nav__icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" role="presentation" focusable="false"><circle cx="12" cy="12" r="8" fill="none" stroke="currentColor" strokeWidth="1.65"/><path d="M12 10.25v5" fill="none" stroke="currentColor" strokeWidth="1.65" strokeLinecap="round"/><circle cx="12" cy="7.75" r=".9" fill="currentColor"/></svg>
            </span>
            <span>About Us</span>
          </Link>
          <button type="button" className="shop-nav__link shop-nav__link--live" onClick={handleLiveSoonOpen}>
            <span className="shop-nav__icon shop-nav__icon--live" aria-hidden="true">
              <span className="shop-nav__live-dot"></span>
            </span>
            <span>Live</span>
          </button>
          <Link to="/contact" className="shop-nav__link">
            <span className="shop-nav__icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" role="presentation" focusable="false"><path d="M5 7.25h14a1.25 1.25 0 0 1 1.25 1.25v7A1.25 1.25 0 0 1 19 16.75H5a1.25 1.25 0 0 1-1.25-1.25v-7A1.25 1.25 0 0 1 5 7.25Z" fill="none" stroke="currentColor" strokeWidth="1.65"/><path d="M4.5 8l7.1 5.2a.7.7 0 0 0 .8 0L19.5 8" fill="none" stroke="currentColor" strokeWidth="1.65" strokeLinecap="round" strokeLinejoin="round"/></svg>
            </span>
            <span>Contact Us</span>
          </Link>
        </nav>

        {showMobileMenu && (
          <div className="mobile-nav-menu">
            <Link to="/" className="mobile-nav-menu__link" onClick={() => setShowMobileMenu(false)}>
              Home
            </Link>
            <Link to="/shop" className="mobile-nav-menu__link" onClick={() => setShowMobileMenu(false)}>
              Shop
            </Link>
            <Link to="/wishlist" className="mobile-nav-menu__link" onClick={() => setShowMobileMenu(false)}>
              My Wishlist
            </Link>
            <Link to="/about-us" className="mobile-nav-menu__link" onClick={() => setShowMobileMenu(false)}>
              About Us
            </Link>
            <button type="button" className="mobile-nav-menu__link mobile-nav-menu__button mobile-nav-menu__link--live" onClick={handleLiveSoonOpen}>
              <span className="mobile-nav-menu__live-dot" aria-hidden="true"></span>
              <span>Live</span>
            </button>
            <Link to="/contact" className="mobile-nav-menu__link" onClick={() => setShowMobileMenu(false)}>
              Contact Us
            </Link>
          </div>
        )}

        <SearchBar
          onView={(product) => {
            setPendingProduct(product);
            setViewItem(product);
          }}
          handleAddToCart={handleAddToCart}
        />

        <button className="cart-button" onClick={toggleSidebar}>
          <span className="cart-button__icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" role="presentation" focusable="false">
              <path d="M3.75 4.75h2.5l1.3 7.2a1 1 0 0 0 .98.82H17.5a1 1 0 0 0 .97-.77l1.28-5.25H7.4" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
              <circle cx="9.5" cy="18.25" r="1.15" fill="none" stroke="currentColor" strokeWidth="1.75"/>
              <circle cx="17" cy="18.25" r="1.15" fill="none" stroke="currentColor" strokeWidth="1.75"/>
            </svg>
          </span>
          <span className="cart-button__label">Cart</span>
          {totalItems > 0 && <span className="cart-count">{totalItems}</span>}
        </button>
      </header>

      {viewItem && (
        <div className="modal-overlay" onClick={() => setViewItem(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setViewItem(null)}>&times;</button>
            <img src={`${oneSystem}${viewItem.imageUrl}`} alt={viewItem.name} style={{ width: "100%", maxHeight: 200, objectFit: "contain" }} />
            <h2>{viewItem.name}</h2>
            <p>PHP {parseFloat(viewItem.pricePHP).toLocaleString()}</p>
            <button
              className="modal-button"
              onClick={async () => {
                if (user) {
                  await addToCart(viewItem);
                  navigate("/checkout");
                } else {
                  setShowModal(true);
                }
                setViewItem(null);
              }}
            >
              Checkout
            </button>
          </div>
        </div>
      )}

      {showLiveSoonModal && (
        <div className="modal-overlay" onClick={() => setShowLiveSoonModal(false)}>
          <div className="modal-content live-soon-modal" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setShowLiveSoonModal(false)}>&times;</button>
            <div className="live-soon-modal__badge">
              <span className="live-soon-modal__pulse"></span>
              <span>Live</span>
            </div>
            <h2>Live will be available soon</h2>
            <p>We're preparing this feature now. Please check back soon for our live selling updates.</p>
          </div>
        </div>
      )}

      <LoginRegisterModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onSuccess={() => {
          if (pendingProduct) {
            addToCart(pendingProduct).then(() => {
              setPendingProduct(null);
              navigate("/checkout");
            });
          }
          setShowModal(false);
        }}
      />
    </>
  );
}

export default Header;

